import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToasterModule as ToastModule } from 'angular2-toaster';
import { AppointmentDataModule } from '../appointment-data/appointment-data.module';
import { AuthModule } from '../auth/auth.module';
import { BillingDataModule } from '../billing-data/billing-data.module';
import { ClientDataModule } from '../client-data/client-data.module';
import { CreditMemoDataModule } from '../credit-memo-data/credit-memo-data.module';
import { DialogModule } from '../dialog/dialog.module';
import { EstimateDataModule } from '../estimate-data/estimate-data.module';
import { ExpenseDataModule } from '../expense-data/expense-data.module';
import { ExportDataModule } from '../export-data/export-data.module';
import { FeaturesModule } from '../features/features.module';
import { FormMasterModule } from '../form-master/form-master.module';
import { GeolocationDataModule } from '../geolocation-data/geolocation-data.module';
import { InvoiceDataModule } from '../invoice-data/invoice-data.module';
import { ItemDataModule } from '../item-data/item-data.module';
import { NotificationDataModule } from '../notification-data/notification-data.module';
import { OnboardingDataModule } from '../onboarding-data/onboarding-data.module';
import { PaymentsDataModule } from '../payments-data/payments-data.module';
import { PollerModule } from '../poller/poller.module';
import { PurchaseOrderDataModule } from '../purchase-order-data/purchase-order-data.module';
import { RendererModule } from '../renderer/renderer.module';
import { ReportDataModule } from '../report-data/report-data.module';
import { SearchDataModule } from '../search-data/search-data.module';
import { SharedModule } from '../shared/shared.module';
import { StatementDataModule } from '../statement-data/statement-data.module';
import { TrackedTimeDataModule } from '../tracked-time-data/tracked-time-data.module';
import { TrackedTimeMasterModule } from '../tracked-time-master/tracked-time-master.module';
import { FeedbackDataModule } from '../feedback-data/feedback-data.module';
import { ReferAFriendDataModule } from '../refer-a-friend-data/refer-a-friend-data.module';
import { SupportDataModule } from '../support-data/support-data.module';
import * as fromGuards from './guards';
import * as fromComponents from './components';
import * as fromContainers from './containers';
import { InvoiceMatchPaymentsDataModule } from '../invoice-match-payments-data/invoice-match-payments-data.module';
import { HomeDataModule } from '../home-data/home-data.module';
import { PricingDataModule } from '../pricing-data/pricing-data.module';
import { ReviewDataModule } from '../review-data/review-data.module';
import { VerifyAccountModule } from '../verify-account/verify-account.module';
import { GlobalHeaderV2Module } from '../global-header-v2/global-header-v2.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    AuthModule,
    DialogModule,
    TrackedTimeMasterModule,
    HomeDataModule.forRoot(),
    ClientDataModule.forRoot(),
    ExpenseDataModule.forRoot(),
    ItemDataModule.forRoot(),
    InvoiceDataModule.forRoot(),
    EstimateDataModule.forRoot(),
    CreditMemoDataModule.forRoot(),
    PurchaseOrderDataModule.forRoot(),
    RendererModule.forRoot(),
    NotificationDataModule.forRoot(),
    PaymentsDataModule.forRoot(),
    BillingDataModule.forRoot(),
    OnboardingDataModule.forRoot(),
    PollerModule.forRoot(),
    StatementDataModule.forRoot(),
    ReportDataModule.forRoot(),
    TrackedTimeDataModule.forRoot(),
    AppointmentDataModule.forRoot(),
    ExportDataModule.forRoot(),
    ToastModule.forRoot(),
    GeolocationDataModule.forRoot(),
    SearchDataModule.forRoot(),
    FeedbackDataModule.forRoot(),
    PricingDataModule.forRoot(),
    ReferAFriendDataModule.forRoot(),
    InvoiceMatchPaymentsDataModule.forRoot(),
    SupportDataModule.forRoot(),
    ReviewDataModule.forRoot(),
    FormMasterModule,
    FeaturesModule,
    VerifyAccountModule,
    RouterModule,
    GlobalHeaderV2Module,
  ],
  declarations: [...fromContainers.containers, ...fromComponents.components],
  providers: [...fromGuards.guards],
})
export class MainModule {}
